import { ReactNode } from 'react';
import { Text } from '@belong/ui';
import css from './vertical-slide-animation.module.css';

type VerticalSlideAnimationProps = {
  elements: ReactNode[];
};

export function VerticalSlideAnimation({
  elements,
}: VerticalSlideAnimationProps) {
  return (
    <div className={css.container}>
      <ul className={css.list}>
        {elements.map((elem, idx) => (
          <li className={css.item} key={idx}>
            <Text variant="h3" fontWeight="semibold">
              {elem}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  );
}
